import WmsMobileLayout from "../wmsMobileLayout";
import {FormattedMessage} from "react-intl";

import PageTitle from "components/WMS/Mobile/PageTitle";
import MyTasks from "components/WMS/Mobile/MyTasks";

import MissionResume from "./components/MissionResume";

function Dashboard() {
    return (
        <WmsMobileLayout>
            <WmsMobileLayout.Content>
                <PageTitle
                    title={<FormattedMessage id={"wms.dashboard.title"}/>}
                    subtitle={<FormattedMessage id={"wms.dashboard.subtitle"}/>}
                />
                <MyTasks/>
                <MissionResume/>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default Dashboard;
